<div class="card kpi-yellow">
    <div class="card-body kpi-card">
        <h5 class="card-title">Niveau de vie moyen</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }} €
            </ng-container>
        </p>
    </div>
</div>
